import styled from 'styled';

import { ListItemLabel } from 'components/ui/list-item-label';
import { space } from 'helpers/style';

export const RelatedStopListItem = styled(ListItemLabel)`
  background-color: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.grayL90};
  user-select: none;
  pointer-events: none;

  &:hover {
    border: 1px solid ${({ theme }) => theme.color.grayL90};
    cursor: default;
  }
`

export const StyledPopOverMenu = styled.div`
  pointer-events: auto;
  margin-left: auto;
`

export const NoRelatedStops = styled.div`
  text-align: center;	  
  padding-top: ${space(6)};
  padding-bottom: ${space(6)};
  margin-bottom: ${space(3)};
  border: 1px solid ${({ theme }) => theme.color.grayL80};
`

